import { render } from "./ObjectListField.vue?vue&type=template&id=49afdf6f&scoped=true"
import script from "./ObjectListField.vue?vue&type=script&lang=js"
export * from "./ObjectListField.vue?vue&type=script&lang=js"

import "./ObjectListField.vue?vue&type=style&index=0&id=49afdf6f&lang=scss"
import "./ObjectListField.vue?vue&type=style&index=1&id=49afdf6f&lang=scss&scoped=true"

import exportComponent from "/app/tmp/360pt/V3/v2026.9.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49afdf6f"]])

export default __exports__